import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { PersistGate } from 'redux-persist/lib/integration/react';

import { createStore } from "redux";
import { Provider } from "react-redux";

import { allReducers, refreshReducers } from "./reducers";
import LanguageSelector from './components/LanguageSelector'

// const store = createStore(allReducers);

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['LoadingReducer', 'ModalReducer']
}

const persistedReducer = persistReducer(persistConfig, allReducers)
export const store = createStore(persistedReducer);
// export const storeRefresh = createStore(refreshReducers);

export const persistor = persistStore(store);

export const purgeData = async () => {
  console.log("CLEAR DATA");
  await persistor.purge();
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  // <Provider store={storeRefresh}>
  <Provider store={store}>

    <PersistGate loading={null} persistor={persistor}>
      {/* <I18nextProvider i18n={i18n}><App /></I18nextProvider>, */}
      {/* <LanguageSelector /> */}
      <App />
    </PersistGate>
  </Provider>

  // </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
